import { number, defaultProvider } from "starknet";

export function waitForTxV2(
  txHash: number.BigNumberish,
  func: Function,
  retryInterval: number = 1000
) {
  const interval = setInterval(async () => {
    const transactionResponse = await defaultProvider.getTransactionStatus(
      txHash
    );
    console.log("[TRANSACTION STATUS]: ", transactionResponse.tx_status);
    func(transactionResponse.tx_status);

    if (
      transactionResponse.tx_status === "PENDING" || // Success State
      transactionResponse.tx_status === "ACCEPTED_ONCHAIN" || // Success State
      transactionResponse.tx_status === "REJECTED" // Failure State
    ) {
      clearInterval(interval);
    }
  }, retryInterval);
}

export function debounce(func: Function, timeout = 300) {
  let timer: any;
  // @ts-ignore
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      // @ts-ignore
      func.apply(this, args);
    }, timeout);
  };
}
